/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {handleThreeDomainSecureRedirect} from '../api'

export const useMutationHandleThreeDomainSecureRedirect = createReactQueryMutationHook('handleThreeDomainSecureRedirect', handleThreeDomainSecureRedirect)
